import React, { useEffect, useState } from 'react';

function TargetingQueOption() {
    const [userData, setUserData] = useState()


    useEffect(() => {
        let userData = JSON.parse(localStorage.getItem('user'));
        setUserData(userData);
   

    }, [])
    const logOut = () => {
        localStorage.clear();
    }
    return (
        <div>
            <section id="all-section" className="admin-header">
                <nav className="navbar navbar-expand-lg bg-white p-0 border border-bottom">
                    <div className="container-fluid ">
                        <a className="navbar-brand1" href="#"><img src="../images/new-logo.png" width="100px" alt="" /></a>
                        <ul className="navbar-nav flex-row">

                            <li className="nav-item dropdown">
                                <a className="nav-link nav dropdown-toggle d-flex align-items-center" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src="../images/2@2x.png" width="50px" className='rounded-circle' alt="" /><p className='aname m-0 px-2 text-black'>{userData && userData.fullName}</p><i className="text-black bi bi-chevron-down"></i>
                                </a>
                                <ul className="dropdown-menu dropdown-menu-lg-end">
                                        <li><a className="dropdown-item border-bottom" href="#"><i className="bi bi-person-fill pe-2" />Profile</a></li>
                                        <li><a className="dropdown-item" onClick={logOut}><i className="fa fa-sign-out pe-2" aria-hidden="true" />Logout</a></li></ul>
                            </li>
                        </ul>
                    </div></nav>
            </section>
            <section id="all-section" className="section-survey ">
                <div className="container-fluid ">
                    <div className="row ">
                        {/* Sidebar  */}
                        {/* Page Content  */}
                        <div className="col-md-8 col-lg-9">
                            <div id="content" className="w-100 p-0 m-0 mt-3">
                                <div className=" px-3 pt-4 pb-2 h-100 w-100 bg-white templateListSec ">
                                    <h6 className="mb-4 targetHdng">Targeting options</h6>
                                    <div className="w-100 innterselectSec mb-3 bg-light">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <select className="form-select w-100 mb-4 selectInnr">
                                                    <option>All category</option>
                                                    <option>All category</option>
                                                </select>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend ">
                                                        <span className="input-group-text selectInnr"><i className="fa fa-search" aria-hidden="true" /></span>
                                                    </div>
                                                    <input className="form-control selectInnr" type="text" placeholder="Search" style={{ borderLeft: 'none' }} />
                                                </div>
                                            </div>
                                        </div>
                                        <p>Look for specific targeted responses by adding targeting options. Your selections will narrow what users you are looking for, while removing selections will widen the user panel.</p>
                                        <h6 className="mb-3 mt-2">Most Popular</h6>
                                        <ul className="populrSur">
                                            <li><a href="targeting-options1.html">Ages of children <span>+</span></a></li>
                                            <li><a href="targeting-options1.html">Education level - India <span>+</span></a></li>
                                            <li><a href="#">Ethnicity - Select countries <span>+</span></a></li>
                                            <li><a href="#">Gender of children <span>+</span></a></li>
                                            <li><a href="#">Graduation Year from U.... <span>+</span></a></li>
                                            <li><a href="#">India - Socio Economic... <span>+</span></a></li>
                                            <li><a href="#">Ages of children <span>+</span></a></li>
                                            <li><a href="#">Education level - India <span>+</span></a></li>
                                            <li><a href="#">Ethnicity - Select countries <span>+</span></a></li>
                                            <li><a href="#">Gender of children <span>+</span></a></li>
                                            <li><a href="#">Graduation Year from U.... <span>+</span></a></li>
                                            <li><a href="#">India - Socio Economic... <span>+</span></a></li>
                                            <li><a href="#">Ages of children <span>+</span></a></li>
                                            <li><a href="#">Education level - India <span>+</span></a></li>
                                            <li><a href="#">Ethnicity - Select countries <span>+</span></a></li>
                                            <li><a href="#">Gender of children <span>+</span></a></li>
                                            <li><a href="#">Graduation Year from U.... <span>+</span></a></li>
                                            <li><a href="#">India - Socio Economic... <span>+</span></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="py-3 px-3 templateCatSelect bg-white  mt-3" style={{ border: '1px solid #D8D8D8' }}>
                                <h5 className="mb-4 targetHdng">Your selections</h5>
                                <h6 className="pt-5 text-center noTargetTxt">No targeting options selected. Choose a category and select the attributes you want to target.</h6>
                                <p className="text-center mt-5"><a href="#" className="mainbtn mainBtnDIsable text-white w-75 d-block mx-auto" style={{ padding: '10px 30px' }}>Apply</a></p>
                            </div>
                        </div>
                        {/* jQuery CDN - Slim version (=without AJAX) */}
                        {/* Popper.JS */}
                        {/* Bootstrap JS */}
                        {/* jQuery Custom Scroller CDN */}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default TargetingQueOption
